// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1craG","title":"BackImages_title__29Toc","images":"BackImages_images__2MzX7"};